import { useEffect } from 'react'
import type { ReactNode } from 'react'
import LandingNav from './LandingNav'
import LandingFooter from './LandingFooter'

interface LegalPageProps {
  title: string
  lastUpdated: string
  children: ReactNode
}

export default function LegalPage({ title, lastUpdated, children }: LegalPageProps) {
  useEffect(() => {
    document.title = `${title} — GCodr`
  }, [title])

  return (
    <div className="min-h-screen bg-[#030712] flex flex-col">
      <LandingNav />

      <div className="flex-1 pt-14">
        {/* Header */}
        <div className="max-w-4xl mx-auto px-6 pt-16 pb-8 text-center">
          <h1
            className="text-3xl md:text-5xl font-extrabold tracking-tight mb-4"
            style={{
              fontFamily: 'Barlow, sans-serif',
              fontWeight: 900,
              background: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              filter: 'drop-shadow(0 0 16px rgba(6, 182, 212, 0.3))',
            }}
          >
            {title}
          </h1>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-500/5 border border-slate-500/20">
            <span className="font-mono text-xs text-slate-400">Last updated: {lastUpdated}</span>
          </div>
        </div>

        {/* Content card */}
        <div className="max-w-3xl mx-auto px-6 pb-24">
          <div className="glass rounded-xl p-8 md:p-12 legal-content">
            {children}
          </div>
        </div>
      </div>

      <LandingFooter />
    </div>
  )
}
